import { mapState } from 'vuex'

var csvGenerator = {
  methods: {
    arrayToCsv(array = [], filename = '', headers = []) {
      if (!array || !array.length) {
        return
      }

      const separator = ','
      let keys = []
      // keep only the headers passed in; headers are key/value pair for pretty headers
      if (headers.length) {
        keys = headers.map(x => x.key)
      } else {
        keys = Object.keys(array[0])
      }

      let csvContent =
        csvGenerator.methods.headerFormat(headers, keys, separator) +
        '\n' +
        array
          .map(row => {
            return keys
              .map(k => {
                let cell = row[k] === null || row[k] === undefined ? '' : row[k]

                if (csvGenerator.methods.isArrayObject(cell)) {
                  cell = ''
                }

                if (cell === '—') {
                  cell = '-'
                }

                cell = cell instanceof Date ? cell.toLocaleString() : cell.toString().replace(/"/g, '""')
                if (cell.search(/("|,|\n)/g) >= 0) {
                  cell = `"${cell}"`
                }

                return cell
              })
              .join(separator)
          })
          .join('\n')

      // add attorney client header
      if (this.currentClientACPReview) {
        csvContent = this.currentClientHeaderTextReviews + '\n' + csvContent
      }

      csvGenerator.methods.generateLink(csvContent, filename)
    },
    tableToCsv: function(table, filename = '', headers = [], bedSizeActive = false, currentClient = '', showTitle = true) {
      if (!table || table === undefined) {
        return
      }

      let table2 = table.cloneNode(true)
      // remove element fixed table clone
      if (table2.querySelectorAll('.el-table__fixed').length) {
        let temp = table2.querySelectorAll('.el-table__fixed')
        for (let e = 0; e < temp.length; e++) {
          table2.removeChild(temp[e])
        }
      }

      // convert html table to array
      let tableInfo
      if (!bedSizeActive) {
        tableInfo = Array.prototype.map.call(table2.querySelectorAll('tr'), function(tr) {
          return Array.prototype.map.call(tr.querySelectorAll('th,td'), function(td) {
            return td.innerText.trim() === '—' ? '-' : td.innerText.trim()
          })
        })
      } else {
        tableInfo = csvGenerator.methods.bedSizeRowExtractor(table2, currentClient, showTitle)
      }

      // get heading on first row and rebuild array with keys
      let heading = tableInfo.shift()
      tableInfo = tableInfo.map((x, i) => {
        let z = {}
        heading.forEach((y, j) => {
          z[y] = x[j]
        })
        return z
      })

      this.arrayToCsv(tableInfo, filename, headers)
    },
    generateLink(csvContent, filename) {
      // colorado
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      // const file = new File([blob], filename)
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, filename)
      } else {
        const link = document.createElement('a')
        if (link.download !== undefined) {
          // Browsers that support HTML5 download attribute
          const url = URL.createObjectURL(blob)
          link.setAttribute('style', 'display: none; float: left; position: absolute;')
          link.setAttribute('download', filename)
          link.setAttribute('target', '_blank')
          link.id = 'hiddenLinkCSV'
          link.href = url
          link.onclick = function(e) {
            e.cancelBubble = true
          }
          document.getElementsByTagName('body')[0].appendChild(link)
          document.getElementById('hiddenLinkCSV').click()
          let timerId = setInterval(() => {
            URL.revokeObjectURL(url)
            document.getElementById('hiddenLinkCSV').remove()
            clearInterval(timerId)
          }, 500)
        }
      }
    },
    headerFormat(headers, keys, separator) {
      return headers.length ? headers.map(x => x.value).join(separator) : keys.join(separator)
    },
    isArrayObject: function(value) {
      if (Array.isArray(value)) {
        return true
      }
      if (value && typeof value === 'object' && value.constructor === Object) {
        return true
      }
    },
    escapeRegExp: function(text) {
      return text.replace(/[-[\]{}()*+?.,\\/^$|#\s]/g, '\\$&')
    },
    bedSizeRowExtractor(table, currentClient, showTitle) {
      let data = []
      let childExtractor = function(el, index, title) {
        return Array.prototype.map.call(el, function(td, i) {
          let node = td.querySelector(`.cell div:nth-child(${index})`)
          // title
          if (i === 0 && showTitle) {
            return title
          }
          // value
          if (node !== null) {
            return node.innerText.trim() === '—' ? '-' : node.innerText.trim()
          }
        })
      }
      Array.prototype.map.call(table.querySelectorAll('tr'), function(tr, i, arr) {
        if (i === 0) {
          let headers = Array.prototype.map.call(tr.querySelectorAll('th,td'), function(td) {
            return td.innerText
          })
          data.push(headers)
        } else {
          // check for summary row
          if (arr.length - 1 !== i) {
            let child1 = childExtractor(tr.querySelectorAll('td'), 1, `${currentClient} data`)
            let child2 = childExtractor(tr.querySelectorAll('td'), 2, 'HIA bed size data')
            let child3 = childExtractor(tr.querySelectorAll('td'), 3, 'All HIA bed size data')
            data.push(child1, child2, child3)
          } else {
            let summary = Array.prototype.map.call(tr.querySelectorAll('th,td'), function(td, i) {
              if (i === 0) {
                return `${currentClient} data summary`
              }
              return td.innerText.trim() === '—' ? '-' : td.innerText.trim()
            })
            data.push(summary)
          }
        }
      })
      return data
    }
  },
  computed: {
    ...mapState('user/', ['user', 'currentClient', 'currentClientACPReview', 'currentClientHeaderTextReviews'])
  }
}

export default csvGenerator
